import React from 'react';

import MaskedInput, { MaskedInputProps } from './MaskedInput';

export interface MaskedInputSSNProps extends MaskedInputProps {}

const MaskedInputSSN: React.FC<MaskedInputSSNProps> = (props) => (
  <MaskedInput
    {...props}
    mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    placeholder="000-00-0000"
    inputMode="numeric"
  />
);

export default MaskedInputSSN;
